import fetch from '../utils/fetch'

export function setPageParams (query) {
  return fetch({
    url: '/distributor/pageparams/setting',
    method: 'post',
    data: query
  })
}

export function getParamByTempName (query) {
  return fetch({
    url: '/distributor/pageparams/setting',
    method: 'get',
    params: query
  })
}
export function updateParamsById (query) {
  return fetch({
    url: '/distributor/pageparams/setting',
    method: 'put',
    data: query
  })
}

export function savePageParams (query) {
  return fetch({
    url: '/distributor/pageparams/setting_all',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/distributor_template.js